<script setup>
defineProps({
  // { head: string[], rows: Array<Array<string>> }  (row[0] = label; cells may contain HTML)
  compare: { type: Object, default: null },
  // optional section heading
  title: { type: String, default: '' }
})
</script>

<template>
  <section class="block tight" v-if="compare">
    <div class="wrap">
      <div class="sec-h"><h2>{{ title || 'Comparison' }}</h2></div>
      <div class="cmp-table">
        <table>
          <thead>
            <tr>
              <th v-for="(h, i) in compare.head" :key="i">{{ h }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, r) in compare.rows" :key="r">
              <th>{{ row[0] }}</th>
              <td
                v-for="(cell, c) in row.slice(1)"
                :key="c"
                v-html="cell"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
